import Tickets from "@/pages/Tickets";

export default function Manutenzione() {
  return <Tickets area="manutenzione" />;
}
